var map = {
	"./1.mp3": "0426",
	"./10.mp3": "ee35",
	"./11.mp3": "f14b",
	"./12.mp3": "dd0e",
	"./13.mp3": "3d71",
	"./14.mp3": "29cb",
	"./15.mp3": "5ee7",
	"./16.mp3": "bb77",
	"./17.mp3": "959b",
	"./18.mp3": "c774",
	"./2.mp3": "6849",
	"./3.mp3": "0124",
	"./4.mp3": "6653",
	"./5.mp3": "d6ee",
	"./6.mp3": "ec12",
	"./7.mp3": "4567",
	"./8.mp3": "5ddf",
	"./9.mp3": "54fc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e05c";